import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVerticalAlignmentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"vertical-alignment-right"} maskId="square-filled-radius-0-stroke-1-IconVerticalAlignmentRight"><path d="M21 3H20V21H21V3Z" fill="currentColor"/><path d="M3 6V11H18V6H3Z" fill="currentColor"/><path d="M7 13V18H18V13H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVerticalAlignmentRight;
